/**
 * Adapts messages to the old format (before formatVersion 2)
 * 
 * Changes the senders and receivers fields to numbers instead of names
 * 
 * @param {Object} storyData - The story data to adapt
 * @returns {Object[]} The updated messages
 * 
 * @example
 * const storyData = {
 *  contacts: [{ name: 'Alice', number: '1' }, { name: 'Bob', number: '2' }],
 *  messages: [{ senders: ['Alice'], receivers: ['Bob'] }]
 * };
 * adaptMessagesToOldFormat(storyData);
 * // Returns [{ senders: ['1'], receivers: ['2'] }]
 */
const adaptMessagesToOldFormat = (storyData) => {
  const contactsMap = {}; // Create a map to associate names with numbers
  storyData.contacts.forEach(contact => {
    contactsMap[contact.name] = contact.number;
  });
  contactsMap['user'] = '0';

  const updatedMessages = storyData.messages.map(message => ({
    ...message,
    senders: message.senders.map(sender => contactsMap[sender] || sender),
    receivers: message.receivers.map(receiver => contactsMap[receiver] || receiver),
  }));
  return updatedMessages;
};

/**
 * Adapts events to the old format (before formatVersion 2)
 * 
 * Changes the senders and receivers fields of messages to numbers instead of names
 * 
 * @param {Object} storyData - The story data to adapt
 * @returns {Object[]} The updated events
 *
 * @example
 * const storyData = {
 *  contacts: [{ name: 'Alice', number: '1' }, { name: 'Bob', number: '2' }],
 *  events: [{ consequence: { type: 'message', message: { senders: ['Alice'], receivers: ['Bob'] } } }]
 * };
 * 
 * adaptEventsToOldFormat(storyData);
 * // Returns [{ consequence: { type: 'message', message: { senders: ['1'], receivers: ['2'] } } }]
 */
const adaptEventsToOldFormat = (storyData) => {
  const contactsMap = {}; // Create a map to associate names with numbers
  storyData.contacts.forEach(contact => {
    contactsMap[contact.name] = contact.number;
  });
  contactsMap['user'] = '0';

  const updatedEventsMessages = storyData.events.map(event => ({
    ...event,
    consequence: event.consequence.type === 'message' ? {
      ...event.consequence,
      message: {
        ...event.consequence.message,
        senders: event.consequence.message.senders.map(sender => contactsMap[sender] || '0'),
        receivers: event.consequence.message.receivers.map(receiver => contactsMap[receiver] || '0'),
      },
    } : event.consequence,
  }));
  return updatedEventsMessages;
};

export { adaptMessagesToOldFormat, adaptEventsToOldFormat };